let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("6zoXD")).then(() => parcelRequire('3FJdS'));